import { useQuery } from '@tanstack/react-query'
import { tenantsApi, TenantListParams } from '../api'

export function useTenants(
  page: number = 1,
  limit: number = 10,
  search: string = '',
  sortBy: string = 'createdAt',
  sortOrder: 'asc' | 'desc' = 'desc'
) {
  return useQuery({
    queryKey: ['tenants', page, limit, search, sortBy, sortOrder],
    queryFn: async () => {
      const params: TenantListParams = {
        page,
        limit,
        search: search || undefined,
        sort_by: sortBy,
        sort_order: sortOrder
      }
      const response = await tenantsApi.list(params)
      return response.data.data
    },
  })
}
